import { Component, OnInit } from '@angular/core';
import { MessageService, TreeNode } from 'primeng/api';
import { ConfigurationActivityService } from '../services/activity-service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UpdateActivity } from '../models/activity.model';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.scss'
})
export class ActivityComponent implements OnInit {
  activityList: TreeNode[];
  cols: any[];
  activityForm: FormGroup;
  displayEditDialog: boolean = false;
  selectedActivity: any;
  selectedId: any;

  constructor(
    private messageService: MessageService,
    private activityService: ConfigurationActivityService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.inItColumns();
    this.getAllActivityList();
    this.initForm();
  }

  inItColumns() {
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'description', header: 'Description' },
      { field: 'color', header: 'Color' },
      { field: 'actionType', header: 'Action Type' },
      { field: 'createdBy', header: 'Created By' },
      { field: 'lastUpdatedBy', header: 'Last Updated By' },
      { field: 'action', header: 'Action' }
    ];
  }

  initForm() {
    this.activityForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      color: ['']
    });
  }

  getAllActivityList() {
    this.activityService.getAllActivity().subscribe({
      next: (data) => {
        this.activityList = this.transformToTreeNodes(data);
        if (this.selectedId) {
          this.expandToSelectedNode(this.activityList);
      }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: "Failed to fetch activity list"
        });
      }
    });
  }

  transformToTreeNodes(data: any[]): TreeNode[] {
    return data.map(item => this.createModuleNode(item));
  }

  createModuleNode(item: any): TreeNode {
    const moduleNode: TreeNode = {
      data: {
        name: item.name,
        description: '',
        color: '',
        actionType: '',
        createdBy: '',
        lastUpdatedBy: '',
        nodeType: 'module'
      },
      expanded: false
    };

    if (item.childModule && item.childModule.length > 0) {
      moduleNode.children = item.childModule.map(childModule => ({
        data: {
          name: childModule.name,
          description: '',
          color: '',
          actionType: '',
          createdBy: '',
          lastUpdatedBy: '',
          nodeType: 'submodule'
        },
        expanded: false,
        children: this.createActivityNodes(childModule.childActivityTypes || [])
      }));
    }
    else if (item.childActivityTypes && item.childActivityTypes.length > 0) {
      moduleNode.children = this.createActivityNodes(item.childActivityTypes);
    }

    return moduleNode;
  }

  createActivityNodes(activities: any[]): TreeNode[] {
    return activities.map(activity => ({
      data: {
        id: activity.id,
        refId: activity.refId,
        name: activity.name,
        description: activity.description,
        color: activity.colorCode,
        actionType: activity.actionTypeName,
        createdBy: activity.createdByName,
        lastUpdatedBy: activity.lastUpdatedByName || 'N/A',
        nodeType: 'activity'
      }
    }));
  }

  onEdit(node: any) {
    this.selectedActivity = node;
    this.activityForm.patchValue({
      name: node.name,
      description: node.description,
      color: node.color
    });
    this.displayEditDialog = true;
  }

  hideDialog() {
    this.displayEditDialog = false;
    this.activityForm.reset();
  }

  onSubmit() {
    if (this.activityForm.valid) {
      const activityDetails = this.activityForm.getRawValue();
      const data : UpdateActivity = {
        id: this.selectedActivity?.id,
        name: activityDetails?.name,
        description: activityDetails?.description,
        colorCode: activityDetails?.color,
        refId: this.selectedActivity.refId ?? null
      };
      this.activityService.updateActivity(data).subscribe({
        next: (data) => {
          this.displayEditDialog = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: "Activity updated successfully"
          });
          this.getAllActivityList();
         
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Failed to update activity details"
          });
        }
      });
    }
  }

  expandToSelectedNode(nodes: TreeNode[]): boolean {
    for (let node of nodes) {
        if (node.data.id === this.selectedId) {
            return true;
        }
        if (node.children) {
            if (this.expandToSelectedNode(node.children)) {
                node.expanded = true;
                return true;
            }
        }
    }
    return false;
}

//   toggleApplications() {
//     if (this.activityList && this.activityList.length > 0) {
//         const newList = [...this.activityList];
//         newList[0] = { ...newList[0], expanded: !newList[0].expanded };
//         this.activityList = newList;
//     }
// }
}
